import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const Home = lazy(() => import("./pages/Home"));

const App = () => {
  return (
    <Suspense
      fallback={
        <div className="preloader bg-dark">
          <div className="loading-container">
            <div className="loading" />
            <div id="loading-icon">
              <img src="images/logo.png" alt="" />
            </div>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Suspense>
  );
};

export default App;
